import {
  EmailImg,
  FacebookImg,
  GoogleReviewImg,
  InstagramImg,
  LineImg,
  NolimitEngage,
  TikTokImg,
  TwitterImg,
  WhatsappImg,
  YoutubeImg,
} from '@/assets/social-media/social-media-icon';
import { AppStoreSVG, GooglePlayStoreSVG, ThreadsSVG } from '@/features/channels/_shared/assets';
import { TChannelOption } from '@/features/channels/_shared/types/channel.type';

export const getChannelIcon = (channel: TChannelOption) => {
  switch (channel) {
    case 'whatsapp':
      return WhatsappImg;
    case 'instagram':
      return InstagramImg;
    case 'facebook':
      return FacebookImg;
    case 'twitter':
      return TwitterImg;
    case 'email':
      return EmailImg;
    case 'line':
      return LineImg;
    case 'google-review':
      return GoogleReviewImg;
    case 'app-store':
      return AppStoreSVG;
    case 'google-playstore':
      return GooglePlayStoreSVG;
    case 'youtube':
      return YoutubeImg;
    case 'tiktok':
      return TikTokImg;
    case 'threads':
      return ThreadsSVG;
    case 'engage':
      return NolimitEngage;
    default:
      return WhatsappImg;
  }
};
